import ChatContact, { ChatContactPersona } from './ChatContact';
import * as React from 'react';
export interface ChatContactListProps {
    contacts: ChatContactPersona[];
}

export default function ChatContactList(props: ChatContactListProps) {
    return (
        <>
            {props.contacts.map(item => (
                <ChatContact key={item.ImAddress} contactInfo={item} />
            ))}
        </>
    );
}
